module.exports = __webpack_public_path__ + "img/fullscreen-open.688f8be5.svg";